import { defineBlock, BlockWrapper } from '@smartfire/js-block-engine';
import style from './style.module.scss';

export const Anchors = () => {
    return (
        <BlockWrapper.ChildrenBlocks
            gutenbergEditorConfig={{
                allowedBlocks: ['smartfire/anchor-text---anchor-part---anchor'],
                template: [
                    ['smartfire/anchor-text---anchor-part---anchor'],
                    ['smartfire/anchor-text---anchor-part---anchor'],
                    ['smartfire/anchor-text---anchor-part---anchor'],
                    ['smartfire/anchor-text---anchor-part---anchor'],
                ],
                templateLock: false,
            }}
            className={style.children}
        />
    );
};

export default defineBlock({
    Block: Anchors,
    smartProps: {},
    setup: {
        title: 'Ancres',
        parent: ['smartfire/anchor-text'],
    },
});
